export const checkInclude = (id: string | undefined, cartItems: any[]) => {
  const itemIndex =
    Array.isArray(cartItems) && cartItems.findIndex((el) => el.id === id);
  if (itemIndex !== -1) {
    return true;
  } else {
    return false;
  }
};
